"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseButtonArgTypes = exports.BaseButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _excluded = ["className", "disabled", "children", "htmlType", "url", "route", "target"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var BaseButton = function BaseButton(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    children = _ref.children,
    htmlType = _ref.htmlType,
    url = _ref.url,
    route = _ref.route,
    target = _ref.target,
    props = _objectWithoutProperties(_ref, _excluded);
  if ((url || route) && disabled) {
    // It's difficult to disable <a> elements, so instead
    // return plain text that is styled as disabled
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('btn', {
        disabled: disabled
      }, className)
    }, children);
  }
  if (url) {
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      href: disabled ? '' : url,
      target: target || '_blank',
      rel: "noopener noreferrer",
      className: (0, _classnames.default)('btn', className)
    }, props), children);
  }
  if (route) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({
      to: route,
      target: target || '_self',
      className: (0, _classnames.default)('btn', className)
    }, props), children);
  }
  return /*#__PURE__*/_react.default.createElement("button", _extends({}, props, {
    type: htmlType || 'button',
    className: (0, _classnames.default)('btn', {
      disabled: disabled
    }, className),
    disabled: disabled
  }), children);
};

// Shared Storybook control definitions that can be used to compose
// the controls of the other buttons
exports.BaseButton = BaseButton;
var BaseButtonArgTypes = {
  disabled: {
    control: {
      type: 'boolean'
    }
  },
  url: {
    control: {
      type: 'text'
    }
  }
};
exports.BaseButtonArgTypes = BaseButtonArgTypes;